export const ROUTE_NAME = {
  HOME: 'HOME',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  QUESTIONNAIRE: 'QUESTIONNAIRE',
  SIGN_UP: 'SIGN_UP',
  AFTER_SIGNUP_USER_DETAILS: 'AFTER_SIGNUP_USER_DETAILS',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  CREATE_PASSWORD: 'CREATE_PASSWORD',
  NEW_PASSWORD: 'NEW_PASSWORD',
  SUMMARY: 'SUMMARY',
  RESULTS: 'RESULTS',
  TRIAL: 'TRIAL',
  INTAKE: 'INTAKE',
  FEED: 'FEED',
  SEARCH: 'SEARCH',
  PUBLIC_TRIAL: 'PUBLIC_TRIAL',
  PUBLIC_TRIAL_WITH_CONDITION: 'PUBLIC_TRIAL_WITH_CONDITION',
  TREATMENT: 'TREATMENT',
  PUBLIC_TREATMENT: 'PUBLIC_TREATMENT',
  ARTICLES: 'ARTICLES',
  PATIENTS: 'PATIENTS',
  FINANCE: 'FINANCE',
  FINANCE_INTAKE: 'FINANCE_INTAKE',
  PUBLIC_FINANCE: 'PUBLIC_FINANCE',
  UPLOAD: 'UPLOAD',
  CHAT: 'CHAT',
  MAINTENANCE: 'MAINTENANCE',
};

export const ROUTE_PATH = {
  [ROUTE_NAME.HOME]: '/',
  [ROUTE_NAME.LOGIN]: '/login',
  [ROUTE_NAME.RESULTS]: '/dashboard/results', // must go before SUMMARY to be first matched route
  [ROUTE_NAME.SUMMARY]: '/dashboard/summary',
  [ROUTE_NAME.FEED]: '/dashboard/feed',
  [ROUTE_NAME.TRIAL]: '/dashboard/trial/:nctNumber',
  [ROUTE_NAME.LOGOUT]: '/logout',
  [ROUTE_NAME.QUESTIONNAIRE]: '/questionnaire/:questionId',
  [ROUTE_NAME.SIGN_UP]: '/signup',
  [ROUTE_NAME.AFTER_SIGNUP_USER_DETAILS]: '/after-signup-user-details',
  [ROUTE_NAME.INTAKE]: '/intake',
  [ROUTE_NAME.FORGOT_PASSWORD]: '/login/forgot-password',
  [ROUTE_NAME.CREATE_PASSWORD]: '/login/create-password',
  [ROUTE_NAME.NEW_PASSWORD]: '/login/reset-password',
  [ROUTE_NAME.SEARCH]: '/search',
  [ROUTE_NAME.PATIENTS]: '/dashboard/patients',
  [ROUTE_NAME.PUBLIC_TRIAL]: '/trial/:nctNumber',
  [ROUTE_NAME.PUBLIC_TRIAL_WITH_CONDITION]: '/trial/:condition/:nctNumber',
  [ROUTE_NAME.TREATMENT]: '/dashboard/treatment/:nctNumber',
  [ROUTE_NAME.PUBLIC_TREATMENT]: '/treatment/:nctNumber',
  [ROUTE_NAME.PUBLIC_FINANCE]: '/finance',
  [ROUTE_NAME.FINANCE]: '/dashboard/finance',
  [ROUTE_NAME.FINANCE_INTAKE]: '/finance_intake',
  [ROUTE_NAME.ARTICLES]: '/dashboard/articles',
  [ROUTE_NAME.UPLOAD]: '/ai_profile',
  [ROUTE_NAME.CHAT]: '/dashboard/chat',
  [ROUTE_NAME.MAINTENANCE]: '/maintenance.html',
};

const PUBLIC_ROUTE_NAMES = [
  ROUTE_NAME.LOGIN,
  ROUTE_NAME.FORGOT_PASSWORD,
  ROUTE_NAME.CREATE_PASSWORD,
  ROUTE_NAME.NEW_PASSWORD,
  ROUTE_NAME.SEARCH,
  ROUTE_NAME.PUBLIC_TRIAL,
  ROUTE_NAME.PUBLIC_TRIAL_WITH_CONDITION,
  ROUTE_NAME.PUBLIC_TREATMENT,
  ROUTE_NAME.MAINTENANCE,
  ROUTE_NAME.UPLOAD,
  ROUTE_NAME.CHAT,
];

const DASHBOARD_ROUTE_NAMES = [
  ROUTE_NAME.LOGIN,
  ROUTE_NAME.RESULTS,
  ROUTE_NAME.SUMMARY,
  ROUTE_NAME.INTAKE,
  ROUTE_NAME.FORGOT_PASSWORD,
  ROUTE_NAME.CREATE_PASSWORD,
  ROUTE_NAME.NEW_PASSWORD,
  ROUTE_NAME.SEARCH,
  ROUTE_NAME.PUBLIC_TRIAL,
  ROUTE_NAME.PUBLIC_TRIAL_WITH_CONDITION,
  ROUTE_NAME.TRIAL,
  ROUTE_NAME.TREATMENT,
  ROUTE_NAME.PUBLIC_TREATMENT,
  ROUTE_NAME.FINANCE,
  ROUTE_NAME.FINANCE_INTAKE,
  ROUTE_NAME.PATIENTS,
  ROUTE_NAME.PUBLIC_FINANCE,
  ROUTE_NAME.FEED,
  ROUTE_NAME.ARTICLES,
  ROUTE_NAME.MAINTENANCE,
  ROUTE_NAME.INTAKE,
  ROUTE_NAME.UPLOAD,
  ROUTE_NAME.CHAT,
];

export const DASHBOARD_ROUTES = Object.entries(ROUTE_PATH).filter(([name]) => DASHBOARD_ROUTE_NAMES.includes(name))
  .map(([name, path]) => ({ name, path }));

export const PUBLIC_ROUTES = Object.entries(ROUTE_PATH).filter(([name]) => PUBLIC_ROUTE_NAMES.includes(name))
  .map(([name, path]) => ({ name, path }));
